import axios from 'axios'

import { clearH5Session, getH5Token, notifyH5AuthRequired } from '../utils/auth'

const API_BASE_URL = 'http://127.0.0.1:9999'

const request = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
})

function isAuthPath(pathname) {
  return String(pathname || '').startsWith('/api/gui-admin/auth/login')
}

function resolveCurrentRedirect() {
  if (typeof window === 'undefined') return
  const currentPath = `${window.location.pathname || '/'}${window.location.search || ''}`
  return currentPath || '/youtube'
}

request.interceptors.request.use((config) => {
  if (!isAuthPath(config?.url)) {
    const token = getH5Token()
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
})

request.interceptors.response.use(
  (response) => {
    const payload = response?.data ?? {}
    if (payload?.ok === false) {
      return Promise.reject(new Error(payload?.message || '请求失败'))
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'data')) {
      return payload.data
    }
    return payload
  },
  (error) => {
    if (error?.response?.status === 401 && !isAuthPath(error?.config?.url) && !error?.config?.skipAuthRedirect) {
      clearH5Session()
      notifyH5AuthRequired(resolveCurrentRedirect())
    }
    return Promise.reject(new Error(
      error?.response?.data?.message
        || error?.message
        || '请求失败',
    ))
  },
)

export default request
